export default __webpack_public_path__ + "static/media/TheEdison.1592b88f.jpg";